// Module
var code = "<template>\n    <div if.bind=\"width < desktop\" id=\"cg-popup-space\" ref=\"popupSpace\">\n        <div ref=\"backbox\" class=\"back-box\" click.delegate=\"hide()\"></div>\n        <cg-bottom-popup ref=\"popup\" view-model.ref=\"bottomPopup\"></cg-bottom-popup>\n    </div>\n</template>\n";
// Exports
module.exports = code;